import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

function ImageAvatars({ src, alt, source, record }) {
  const resolvedSrc =
    source && record
      ? `${source}`.split(".").reduce((o, i) => o?.[i], record)
      : src;

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Avatar
        alt={alt}
        src={resolvedSrc}
        sx={{
          m: 1,
          width: 60,
          height: 60,
        }}
      />
    </Box>
  );
}

ImageAvatars.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  source: PropTypes.string,
  record: PropTypes.object,
};

export default ImageAvatars;
